import $ from "jquery";
import "jquery-form";

export interface IAjaxFormWrapper {
    submit(options: JQueryFormOptions): JQuery;
}

function createWrapper(element: HTMLElement) {
    function submit(options: JQueryFormOptions) {
        return $(element).ajaxSubmit(options);
    }

    return {
        submit: submit
    };
}

export default {
    createWrapper: createWrapper
};
